<div
  [id]="getSidebarId()"
  class="fixed inset-y-0 start-0 z-[60] flex h-full w-[300px] max-h-full transform flex-col border-e border-gray-200 bg-white transition-transform duration-300 ease-in-out"
  [ngClass]="{
    'translate-x-0': isOpen,
    '-translate-x-full': !isOpen,
    'lg:translate-x-0': isOpen,
    'lg:-translate-x-full': !isOpen
  }"
  role="dialog"
  tabindex="-1"
  aria-label="Sidebar"
  [attr.aria-hidden]="!isOpen"
>
  <div class="relative flex h-full max-h-full flex-col">
    <div
      class="flex items-center justify-between border-b border-gray-200 px-4 py-3"
    >
      <a
        class="inline-block flex-none rounded-xl text-xl font-semibold focus:outline-none"
        href="#"
        aria-label="OneEduca"
      >
        <div class="h-auto w-28">OneEduca</div>
      </a>

      <button
        type="button"
        class="inline-flex size-5 items-center justify-center rounded border border-transparent text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-ring)] lg:hidden"
        (click)="handleCloseSidebar()"
        aria-label="Fechar sidebar"
      >
        <span class="sr-only">Fechar sidebar</span>
        <i class="bi bi-x-lg text-base"></i>
      </button>
    </div>

    <div
      class="h-full overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300"
    >
      <nav class="flex w-full flex-col p-3 pb-6">
        <ng-container [ngSwitch]="variant">
          <ng-container *ngSwitchCase="'course-editor'">
            <div class="mb-3">
              <button
                type="button"
                class="btn-primary flex w-full items-center gap-x-2 px-3 py-2"
                (click)="onAddModule($event)"
              >
                <i class="bi bi-plus-circle"></i>
                <span>Adicionar Módulo</span>
              </button>
            </div>

            <ul
              cdkDropList
              class="flex flex-col space-y-2"
              (cdkDropListDropped)="onModuleDrop($event)"
              *ngIf="course"
            >
              <li
                *ngFor="let module of course.modules; let isLast = last"
                cdkDrag
                class="rounded bg-gray-50/50"
              >
                <div
                  class="flex w-full items-center justify-between rounded px-2.5 py-2 text-sm text-gray-800 hover:bg-gray-100"
                  [attr.aria-expanded]="isMenuOpen(module.id)"
                  tabindex="0"
                  (click)="toggleMenu(module.id)"
                  (keydown.enter)="toggleMenu(module.id)"
                  (keydown.space)="toggleMenu(module.id); $event.preventDefault()"
                >
                  <i
                    cdkDragHandle
                    class="bi bi-grip-vertical flex-shrink-0 cursor-move text-gray-400"
                  ></i>
                  <span class="line-clamp-1 min-w-0 flex-1 ml-2"
                    >{{ module.name }}</span
                  >
                  <i
                    class="bi flex-shrink-0 text-xs"
                    [ngClass]="isMenuOpen(module.id) ? 'bi-chevron-up' : 'bi-chevron-down'"
                  ></i>
                </div>

                <div
                  class="w-full overflow-hidden transition-all duration-300"
                  [ngClass]="{
                    'max-h-0 opacity-0 pointer-events-none': !isMenuOpen(module.id),
                    'max-h-[500px] opacity-100 mt-1': isMenuOpen(module.id),
                    'mb-4': isLast && isMenuOpen(module.id)
                  }"
                >
                  <ul
                    *ngIf="module.contentType === 'lessons'"
                    cdkDropList
                    class="space-y-1 pt-1"
                    (cdkDropListDropped)="onLessonDrop($event, module.id)"
                    [class.hidden]="!isMenuOpen(module.id)"
                  >
                    <li
                      class="relative group ps-3"
                      *ngFor="let lesson of module.lessons"
                      cdkDrag
                    >
                      <div
                        class="flex items-center rounded px-2.5 py-2 text-sm transition-colors"
                        [ngClass]="{
                          'text-gray-800 hover:bg-gray-100/30': !isCurrentLesson(lesson.id),
                          'bg-[var(--color-primary-soft)] text-[var(--color-primary)] hover:bg-[var(--color-primary-muted)]': isCurrentLesson(lesson.id)
                        }"
                      >
                        <a
                          class="flex flex-1 items-center"
                          (click)="onLessonClick(lesson.id, $event)"
                          tabindex="0"
                          role="button"
                        >
                          <i
                            cdkDragHandle
                            class="bi bi-grip-vertical flex-shrink-0 cursor-move text-gray-400"
                          ></i>
                          <i
                            class="bi ml-2"
                            [ngClass]="getLessonIcon(lesson)"
                          ></i>
                          <span class="line-clamp-1 ml-2"
                            >{{ lesson.order }}. {{
                            getLessonDisplayTitle(lesson) }}</span
                          >
                        </a>
                      </div>
                    </li>
                  </ul>

                  <ul
                    *ngIf="module.contentType === 'evaluations' && module.questions"
                    cdkDropList
                    class="space-y-1 pt-1"
                    (cdkDropListDropped)="onQuestionDrop($event, module.id)"
                    [class.hidden]="!isMenuOpen(module.id)"
                  >
                    <li
                      class="relative group ps-3"
                      *ngFor="let question of getSortedQuestions(module.questions)"
                      cdkDrag
                    >
                      <div
                        class="flex items-center rounded px-2.5 py-2 text-sm transition-colors"
                        [ngClass]="{
                          'text-gray-800 hover:bg-gray-100/30': !isCurrentQuestion(question.id),
                          'bg-[var(--color-primary-soft)] text-[var(--color-primary)] hover:bg-[var(--color-primary-muted)]': isCurrentQuestion(question.id)
                        }"
                      >
                        <div
                          class="flex flex-1 cursor-pointer items-center"
                          (click)="onQuestionClick(module.id, question.id, $event)"
                          tabindex="0"
                          role="button"
                        >
                          <i
                            cdkDragHandle
                            class="bi bi-grip-vertical flex-shrink-0 cursor-move text-gray-400"
                          ></i>
                          <i
                            class="bi ml-2"
                            [ngClass]="getQuestionIcon(question.id)"
                          ></i>
                          <span class="line-clamp-1 ml-2"
                            >{{ question.order + 1 }}. {{
                            getQuestionDisplayTitle(question) }}</span
                          >
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>

            <div
              *ngIf="course && course.modules.length === 0"
              class="py-8 text-center text-gray-500"
            >
              <i class="bi bi-inbox mb-2 block text-3xl"></i>
              <p class="text-sm">Nenhum módulo criado ainda</p>
              <p class="mt-1 text-xs">
                Clique em "Adicionar Módulo" para começar
              </p>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'course-viewer'">
            <ul *ngIf="course" class="flex flex-col space-y-2">
              <li
                *ngFor="let module of course.modules; let isLast = last"
                class="rounded bg-gray-50/50"
              >
                <div
                  class="flex w-full cursor-pointer items-center justify-between rounded px-2.5 py-2 text-sm text-gray-800 hover:bg-gray-100"
                  [attr.aria-expanded]="isMenuOpen(module.id)"
                  tabindex="0"
                  (click)="toggleMenu(module.id)"
                  (keydown.enter)="toggleMenu(module.id)"
                  (keydown.space)="toggleMenu(module.id); $event.preventDefault()"
                >
                  <span class="line-clamp-1 min-w-0 flex-1"
                    >{{ module.name }}</span
                  >
                  <i
                    class="bi flex-shrink-0 text-xs"
                    [ngClass]="isMenuOpen(module.id) ? 'bi-chevron-up' : 'bi-chevron-down'"
                  ></i>
                </div>

                <div
                  class="w-full overflow-hidden transition-all duration-300"
                  [ngClass]="{
                    'max-h-0 opacity-0 pointer-events-none': !isMenuOpen(module.id),
                    'max-h-[500px] opacity-100 mt-1': isMenuOpen(module.id),
                    'mb-4': isLast && isMenuOpen(module.id)
                  }"
                >
                  <ul
                    class="space-y-1 pt-1"
                    [class.hidden]="!isMenuOpen(module.id)"
                  >
                    <li
                      class="ps-3"
                      *ngFor="let lesson of module.contentType === 'lessons' ? module.lessons : []"
                    >
                      <a
                        routerLink="/"
                        class="flex items-center gap-x-3.5 rounded px-2.5 py-2 text-sm transition-colors"
                        [ngClass]="{
                          'text-gray-800 hover:bg-gray-100/30': !isCurrentLesson(lesson.id),
                          'bg-[var(--color-primary-soft)] text-[var(--color-primary)] hover:bg-[var(--color-primary-muted)]': isCurrentLesson(lesson.id)
                        }"
                        (click)="onLessonClick(lesson.id, $event)"
                      >
                        <i class="bi" [ngClass]="getLessonIcon(lesson)"></i>
                        <span class="line-clamp-1"
                          >{{ lesson.order }}. {{ lesson.title }}</span
                        >
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </ng-container>
        </ng-container>
      </nav>
    </div>
  </div>
</div>
